require('../../modules/es6.math.imul');
module.exports = require('../../modules/_core').Math.imul;
